/**
 * Exigibilité des pièces CONDITIONNELLES de la grille récap (`PiecesGrid`).
 *
 * Helpers PURS extraits du composant pour rester testables en environnement
 * `node` (même pattern que `piecesGridHebergeur`).
 */

/** Règle cross-check qui exige le récépissé DA en Parcours A. */
export const RECEPISSE_DA_MISSING_RULE_ID = 'recepisse_da_manquant_parcours_a';

/**
 * Le récépissé de déclaration d'achat est exigé dès que le Parcours A est
 * déclenché (vendeur professionnel + titulaire C.1 particulier). On ne re-dérive
 * PAS le Parcours A dans la grille : la SOURCE DE VÉRITÉ est la règle cross-check
 * `recepisse_da_manquant_parcours_a` (évite toute divergence avec la colonne
 * Alertes). Si elle a fait feu (severity `error`), la pièce est requise-et-
 * manquante → la grille doit matérialiser une carte « Manquante ». Avant ce
 * correctif, le manque n'apparaissait qu'en alerte, pas en carte (cas DS-063-CH).
 *
 * @returns true si une carte `recepisse_da` doit figurer dans la grille.
 */
export const isRecepisseDaRequired = (
  hasRecepisseDaUpload: boolean,
  findings: ReadonlyArray<{ ruleId: string; severity: 'error' | 'warning' | 'info' }>,
): boolean =>
  hasRecepisseDaUpload ||
  findings.some((f) => f.ruleId === RECEPISSE_DA_MISSING_RULE_ID && f.severity === 'error');
